export default __webpack_public_path__ + "static/media/pipette_rack_small.31c2de06.svg";